import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
import { STREAMING_TYPE } from "./IQuoteStreamRepo";
var QuoteRequestMapper = /** @class */ (function () {
    function QuoteRequestMapper() {
    }
    QuoteRequestMapper.prototype.formatRequest = function (syms, subscribe, streaming_type) {
        var symbols = syms.map(function (x) {
            return { symbol: x };
        });
        var subReq = {
            request: {
                streaming_type: streaming_type,
                formFactor: "W",
                response_format: "json",
                request_type: subscribe ? "subscribe" : "unsubscribe",
                appID: urlConfig.appid,
            },
            echo: {},
        };
        if (streaming_type === STREAMING_TYPE.MARKET_STATUS) {
            return JSON.stringify(subReq);
        }
        else {
            subReq.request.data = {
                symbols: symbols,
            };
            return JSON.stringify(subReq);
        }
    };
    return QuoteRequestMapper;
}());
export default QuoteRequestMapper;
